import { Security_Status } from '@/__generated__/graphql';
import { MinusScoreIcon } from '@/assets/icons/minusScore';
import Button from '@/components/basicComponents/button';
import { Tooltip } from '@/components/basicComponents/tooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { formatCash } from '@/shared/utils/currency';
import { getUTCDate } from '@/shared/utils/date';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { seekingInterestTableColumns } from '../constants';
import { IInvestorInterestList, TypeWindow } from '../types';

interface OpenOpportunitiesTableBodyProps {
  seekingInterestData: IInvestorInterestList[];
  openPage: (id: string, type: TypeWindow) => void;
  openModalWindow: (type: string, row: IInvestorInterestList) => void;
}

const TableBody = ({ seekingInterestData, openPage, openModalWindow }: OpenOpportunitiesTableBodyProps) => {
  if (!seekingInterestData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {seekingInterestData.map((row) => (
        <TableRowWrapper key={row.investment.id}>
          <TableRowCell width={seekingInterestTableColumns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openPage(row.investment.id, 'opportunityDetails')}>
              {row.investment.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[1].width}>
            <TextCell>
              {row.investment?.subAssetClass
                ? `${row.investment?.assetClass?.name} - ${row.investment?.subAssetClass?.name}`
                : row.investment?.assetClass?.name}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[2].width}>
            <TextCell>
              {row.investment?.subAssetClasses?.length > 1 ? (
                <Tooltip title={row.investment.subAssetClasses.toString().replace(/,/g, ', ')}>
                  Multiple ({row.investment.subAssetClasses.length})
                </Tooltip>
              ) : (
                row.investment?.subAssetClasses && row.investment?.subAssetClasses[0]
              )}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[3].width}>
            <TextCell>{row.investment.type}</TextCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[4].width}>
            <TextCell>{row.investment.investorDocsDue && getUTCDate(new Date(row.investment.investorDocsDue))}</TextCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[5].width}>
            <TextCell>{row.investorInterests.length ? formatCash(row.totalInvestmentAmount) : <></>}</TextCell>
          </TableRowCell>
          <TableRowCell width={seekingInterestTableColumns[6].width}>
            {row.investment.securityStatus === Security_Status.SeekingInterest && (
              <ButtonWrap id="infoWrap">
                {!row.investorInterests.length && !row.totalInvestmentAmount ? (
                  <Button size="sm" onClick={() => openModalWindow('add-to-watchlist', row)}>
                    Add To Watchlist
                  </Button>
                ) : (
                  <Button size="sm" onClick={() => openModalWindow('edit-watchlist', row)}>
                    Edit Watchlist
                  </Button>
                )}
              </ButtonWrap>
            )}
          </TableRowCell>
          {/* <TableRowCell width={seekingInterestTableColumns[7].width}>
            {row.investment.securityStatus !== Security_Status.Approved && (
              <TooltipWrapper>
                <Tooltip title="Passed On">
                  <MinusScoreIcon width={29} height={29} fill={themeVar('font.disabled')} />
                </Tooltip>
              </TooltipWrapper>
            )}
          </TableRowCell> */}
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const ButtonWrap = styled.div`
  opacity: 0;
`;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  top: 3px;
`;
